
import React from 'react';

export const OpenPositionsSection: React.FC = () => {
  const positions = [
    {
      title: 'Senior Business Development Manager',
      department: 'Business Development',
      location: 'Chino Valley, AZ / Remote',
      type: 'Full-time',
      description: 'Lead strategic partnerships and client acquisition initiatives across our authority portfolio. Drive revenue growth through innovative business development strategies.',
      requirements: ['5+ years business development experience', 'Proven track record in B2B sales', 'Strategic thinking and analytical skills', 'Excellent communication abilities']
    },
    {
      title: 'AI Consulting Specialist',
      department: 'AI Consulting Authority',
      location: 'Remote',
      type: 'Full-time',
      description: 'Provide expert AI consulting services to enterprise clients. Develop AI implementation strategies and guide digital transformation initiatives.',
      requirements: ['3+ years AI/ML experience', 'Strong technical background', 'Client-facing experience', 'Knowledge of enterprise AI solutions']
    },
    {
      title: 'Real Estate Development Analyst',
      department: 'Real Estate Authority',
      location: 'Chino Valley, AZ',
      type: 'Full-time',
      description: 'Analyze real estate investment opportunities and support property development projects. Conduct market research and financial modeling.',
      requirements: ['Real estate or finance background', 'Financial modeling skills', 'Market analysis experience', 'Detail-oriented approach']
    },
    {
      title: 'Travel Operations Coordinator',
      department: 'Travel Authority',
      location: 'Remote',
      type: 'Part-time',
      description: 'Coordinate travel operations and client experiences. Manage vendor relationships and ensure exceptional service delivery.',
      requirements: ['Travel industry experience', 'Strong organizational skills', 'Customer service excellence', 'Multi-tasking abilities']
    },
    {
      title: 'Content Marketing Manager',
      department: 'Marketing',
      location: 'Remote',
      type: 'Full-time',
      description: 'Develop and execute content marketing strategies across all authority domains. Create compelling content that drives engagement and growth.',
      requirements: ['Content marketing experience', 'Strong writing skills', 'SEO knowledge', 'Creative thinking']
    },
    {
      title: 'Corporate Governance Specialist',
      department: 'Corporate Affairs',
      location: 'Chino Valley, AZ',
      type: 'Full-time',
      description: 'Ensure compliance with corporate governance standards and regulatory requirements. Support executive decision-making processes.',
      requirements: ['Legal or compliance background', 'Corporate governance knowledge', 'Attention to detail', 'Analytical mindset']
    }
  ];

  return (
    <section id="open-positions" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Open Positions</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover exciting career opportunities across our diverse portfolio of authority domains. Join us in driving innovation and growth.
          </p>
        </div>

        <div className="grid gap-8">
          {positions.map((position, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between mb-6">
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{position.title}</h3>
                  <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-4">
                    <span className="flex items-center">
                      <div className="w-4 h-4 flex items-center justify-center mr-2">
                        <i className="ri-building-line"></i>
                      </div>
                      {position.department}
                    </span>
                    <span className="flex items-center">
                      <div className="w-4 h-4 flex items-center justify-center mr-2">
                        <i className="ri-map-pin-line"></i>
                      </div>
                      {position.location}
                    </span>
                    <span className="flex items-center">
                      <div className="w-4 h-4 flex items-center justify-center mr-2">
                        <i className="ri-time-line"></i>
                      </div>
                      {position.type}
                    </span>
                  </div>
                </div>
                <button 
                  onClick={() => document.getElementById('application')?.scrollIntoView({ behavior: 'smooth' })}
                  className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap lg:ml-6"
                >
                  Apply Now
                </button>
              </div>
              
              <p className="text-gray-700 mb-6 leading-relaxed">{position.description}</p>
              
              <div>
                <h4 className="font-semibold text-gray-900 mb-3">Key Requirements:</h4>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  {position.requirements.map((req, reqIndex) => (
                    <li key={reqIndex} className="flex items-start">
                      <div className="w-4 h-4 flex items-center justify-center mr-3 mt-1">
                        <i className="ri-check-line text-green-600"></i>
                      </div>
                      <span className="text-gray-700">{req}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
